window.addEventListener('turbo:load', function () {
  const params = new URLSearchParams(window.location.search)
  if (!params.has('tier_id')) {
    return
  }

  const sponsorsCountText = document.querySelector<HTMLParagraphElement>('.js-sponsor-count')
  sponsorsCountText?.focus()
})
